import { render } from "./ReportsTableView.vue?vue&type=template&id=8e48b1c4"
import script from "./ReportsTableView.vue?vue&type=script&lang=js"
export * from "./ReportsTableView.vue?vue&type=script&lang=js"

import "./ReportsTableView.vue?vue&type=style&index=0&id=8e48b1c4&lang=css"

import exportComponent from "/gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__